import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import PasswordInput from '../components/PasswordInput';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [token, setToken] = useState('');

  useEffect(() => {
    const tokenParam = searchParams.get('token');
    if (!tokenParam) {
      toast.error('Invalid reset link');
      navigate('/');
    } else {
      setToken(tokenParam);
    }
  }, [searchParams, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      toast.error('Please fill in all fields');
      return;
    }

    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }

    try {
      const response = await axios.post(`${API}/api/auth/reset-password`, {
        token: token,
        new_password: password
      });

      if (response.data.success) {
        toast.success('Password reset successfully! You can now login.');
        setTimeout(() => {
          navigate('/');
        }, 2000);
      }
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Failed to reset password';
      toast.error(errorMsg);
    }
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center px-4"
      style={{ backgroundColor: '#EEE7D8' }}
    >
      <div 
        className="w-full max-w-md p-8 rounded-lg"
        style={{ backgroundColor: '#F3EEE4', border: '1px solid #D6D0C2' }}
      >
        <div className="text-center mb-6">
          <img 
            src="https://customer-assets.emergentagent.com/job_recipehub-15/artifacts/wndzktxu_wellby-logo.svg"
            alt="Wellby"
            className="mx-auto mb-4"
            style={{ height: '60px', width: 'auto' }}
          />
          <h1 
            className="text-3xl font-bold mb-2"
            style={{ fontFamily: "'Instrument Serif', serif", color: '#52120A' }}
          >
            Reset Password
          </h1>
          <p style={{ fontFamily: "'Bricolage Grotesque', sans-serif", color: '#52120A' }}>
            Enter your new password below
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="password" style={{ fontFamily: "'Bricolage Grotesque', sans-serif", color: '#52120A' }}>
              New Password
            </Label>
            <PasswordInput
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ borderColor: '#52120A', fontFamily: "'Bricolage Grotesque', sans-serif" }}
            />
          </div>

          <div>
            <Label htmlFor="confirmPassword" style={{ fontFamily: "'Bricolage Grotesque', sans-serif", color: '#52120A' }}>
              Confirm Password
            </Label>
            <PasswordInput
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              style={{ borderColor: '#52120A', fontFamily: "'Bricolage Grotesque', sans-serif" }}
            />
          </div>

          <Button 
            type="submit" 
            className="w-full"
            style={{ 
              backgroundColor: '#52120A', 
              borderColor: '#52120A', 
              color: 'white', 
              fontFamily: "'Bricolage Grotesque', sans-serif" 
            }}
          >
            Reset Password
          </Button>
        </form>

        <div className="text-center mt-4">
          <button
            type="button"
            onClick={() => navigate('/')}
            className="underline hover:no-underline text-sm"
            style={{ color: '#52120A', fontFamily: "'Bricolage Grotesque', sans-serif" }}
          >
            Back to home
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
